import React from 'react'

import { FilterDrawerWrapper, FilterDrawerFooter, FilterDrawerBody, FilterDrawerHeader, FilterDrawerHeaderClose } from './FilterDrawer.styles'

import FilterBodyContainer from './filterbody/FilterBody.container'
import FilterFooterContainer from './filterfooter/FilterFooter.container'

import Typestack from '../../typestack'
import Icon from '@emcm-ui/component-icon';

const FilterDrawerComponent = ({
  events,
  i18n,
  api,
  extraFilters,
  savedFilters,
  quickFilters,
  headers,
  appliedFilters,
  saveFiltersChecked,
  handleRemove,
  handleFilterOpen,
  handleRemoveFilter,
  validationErrors,
  analytics
}) => {
  return (
    <FilterDrawerWrapper>
      <FilterDrawerHeader>
        <Typestack type='heading' size='md' weight='black'>{i18n.filter}</Typestack>

        <FilterDrawerHeaderClose onClick={events.handleClose}>
        <Icon
          path="./icons/ui/grey/close-07.svg"
          size="s"
        />
        </FilterDrawerHeaderClose>
      </FilterDrawerHeader>

      <FilterDrawerBody>
        <FilterBodyContainer
          analytics={analytics}
          i18n={i18n}
          savedFilters={savedFilters}
          extraFilters={extraFilters}
          setAllFilters={events.setAllFilters}
          quickFilters={quickFilters}
          addAppliedFilter={events.addAppliedFilter}
          handleRemoveFilter={handleRemoveFilter}
          handleRemove={handleRemove}
          headers={headers}
          api={api}
          appliedFilters={appliedFilters}
          handleInputValidationErrors={events.handleInputValidationErrors}
        />
      </FilterDrawerBody>

      <FilterDrawerFooter>
        <FilterFooterContainer
          analytics={analytics}
          i18n={i18n}
          api={api}
          savedFilters={savedFilters}
          saveFiltersChecked={saveFiltersChecked}
          handleSaveFiltersCheck={events.handleSaveFiltersCheck}
          handleFilterOpen={handleFilterOpen}
          handleClearFilters={events.handleClearFilters}
          handleClickApplyFilters={events.handleClickApplyFilters}
          validationErrors={validationErrors}
        />
      </FilterDrawerFooter>
    </FilterDrawerWrapper>
  )
}

export default FilterDrawerComponent
